/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { supabase } from './supabase';
import Login from './pages/Login';
import Onboarding from './pages/Onboarding';
import Locations from './pages/Locations';
import Playlists from './pages/Playlists';
import Contents from './pages/Contents';
import Profile from './pages/Profile';
import Activate from './pages/Activate';
import Account from './pages/Account';
import CRM from './pages/CRM';

const SIDEBAR_W = 230;

export default function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState('locations');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [hasScreens, setHasScreens] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('payment')) setPage('account');
  }, []);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });
    return () => subscription.unsubscribe();
  }, []);

  const checkScreens = async (token) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE}/locations`, { headers: { 'Authorization': `Bearer ${token}` } });
      const data = await res.json();
      const total = (data || []).reduce((a, l) => a + (l.screens || []).length, 0);
      setHasScreens(total > 0);
    } catch (e) { setHasScreens(true); }
  };

  useEffect(() => {
    if (session) checkScreens(session.access_token);
  }, [session]);

  if (loading || (session && hasScreens === null)) return (
    <div style={{ minHeight: '100vh', background: '#F5EFE6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Helvetica Neue, Arial, sans-serif' }}>
      <div style={{ fontSize: 14, color: '#777' }}>Loading...</div>
    </div>
  );

  if (!session) return <Login />;
  if (hasScreens === false) return <Onboarding onComplete={() => { setHasScreens(true); setPage('locations'); }} />;

  const isAdmin = session && session.user && session.user.id === process.env.REACT_APP_ADMIN_USER_ID;

  const tabs = [
	  { id: 'locations', label: 'Locations', icon: '🏪' },
	  { id: 'playlists', label: 'Playlists', icon: '🎵' },
	  { id: 'contents', label: 'Contents', icon: '🖼️' },
	  { id: 'activate', label: 'Activate', icon: '📺' },
	  { id: 'account', label: 'Account', icon: '👤' },
	  ...(isAdmin ? [{ id: 'crm', label: 'CRM', icon: '📊' }] : []),
];

  const navGroups = [
    {
      label: 'MANAGE',
      items: [
        { id: 'locations', icon: '🏪', label: 'Locations' },
        { id: 'playlists', icon: '🎵', label: 'Playlists' },
        { id: 'contents', icon: '🖼️', label: 'Contents' },
        { id: 'activate', icon: '📺', label: 'Activate Screen' },
      ]
    },
    {
      label: 'ADMIN',
      items: [
        { id: 'crm', icon: '📊', label: 'CRM', adminOnly: true },
      ]
    },
    {
      label: 'ACCOUNT',
      items: [
        { id: 'account', icon: '💳', label: 'Account & Plan' },
        { id: 'profile', icon: '👤', label: 'Profile' },
      ]
    }
  ];

  const PageContent = () => (
    <>
      {page === 'locations' && <Locations />}
      {page === 'playlists' && <Playlists />}
      {page === 'contents' && <Contents />}
      {page === 'activate' && <Activate />}
      {page === 'account' && <Account />}
      {page === 'profile' && <Profile />}
      {page === 'crm' && <CRM />}
    </>
  );

  if (isMobile) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', fontFamily: 'Helvetica Neue, Arial, sans-serif', background: '#F8F6F3' }}>
        <div style={{ background: '#111', padding: '10px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
          <div style={{ fontSize: 17, fontWeight: 700, color: '#fff', letterSpacing: -0.3 }}>
            Signage<span style={{ color: '#C45C6A' }}>Panel</span>
          </div>
          <button onClick={() => supabase.auth.signOut()}
            style={{ background: 'none', border: '1px solid #333', borderRadius: 6, color: '#777', fontSize: 11, padding: '4px 10px', cursor: 'pointer' }}>
            Sign Out
          </button>
        </div>

        <div style={{ flex: 1, overflow: 'auto' }}><PageContent /></div>

        <div style={{ background: '#111', display: 'flex', borderTop: '1px solid #1E1E1E', flexShrink: 0, paddingBottom: 'env(safe-area-inset-bottom)' }}>
          {tabs.map(tab => (
            <button key={tab.id} onClick={() => setPage(tab.id)}
              style={{ flex: 1, background: 'none', border: 'none', cursor: 'pointer', padding: '8px 2px 6px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3,
                color: page === tab.id ? '#fff' : '#444',
                borderTop: page === tab.id ? '2px solid #C45C6A' : '2px solid transparent' }}>
              <span style={{ fontSize: 20 }}>{tab.icon}</span>
              <span style={{ fontSize: 9, fontWeight: page === tab.id ? 600 : 400, letterSpacing: 0.2 }}>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', height: '100vh', fontFamily: 'Helvetica Neue, Arial, sans-serif' }}>
      <div style={{ width: SIDEBAR_W, background: '#111', color: '#fff', display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
        <div style={{ padding: '20px 16px 16px', borderBottom: '1px solid #1A1A1A' }}>
          <div style={{ fontSize: 17, fontWeight: 700, letterSpacing: -0.3 }}>
            Signage<span style={{ color: '#C45C6A' }}>Panel</span>
          </div>
          <div style={{ fontSize: 10, color: '#444', marginTop: 2, textTransform: 'uppercase', letterSpacing: 1 }}>Management Dashboard</div>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '12px 8px' }}>
          {navGroups.map(group => {
            const visibleItems = group.items.filter(item => !item.adminOnly || isAdmin);
            if (visibleItems.length === 0) return null;
            return (
              <div key={group.label} style={{ marginBottom: 20 }}>
                <div style={{ fontSize: 9, color: '#333', fontWeight: 700, letterSpacing: 1.2, textTransform: 'uppercase', paddingLeft: 10, marginBottom: 4 }}>{group.label}</div>
                {visibleItems.map(item => (
                  <div key={item.id} onClick={() => setPage(item.id)}
                    style={{ display: 'flex', alignItems: 'center', gap: 9, padding: '8px 10px', borderRadius: 7, cursor: 'pointer', fontSize: 13, marginBottom: 1, fontWeight: page === item.id ? 600 : 400,
                      background: page === item.id ? '#1E1E1E' : 'transparent',
                      color: page === item.id ? '#fff' : '#666',
                      borderLeft: page === item.id ? '3px solid #C45C6A' : '3px solid transparent',
                    }}>
                    <span style={{ fontSize: 15 }}>{item.icon}</span>
                    {item.label}
                  </div>
                ))}
              </div>
            );
          })}
        </div>

        <div style={{ padding: '10px 8px 12px', borderTop: '1px solid #1A1A1A' }}>
          <div onClick={() => supabase.auth.signOut()}
            style={{ display: 'flex', alignItems: 'center', gap: 9, padding: '8px 10px', borderRadius: 7, cursor: 'pointer', fontSize: 13, color: '#555', marginBottom: 4 }}>
            <span style={{ fontSize: 14 }}>🚪</span> Sign Out
          </div>
          <div style={{ fontSize: 10, color: '#333', paddingLeft: 10, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {session.user.email}
          </div>
        </div>
      </div>

      <div style={{ flex: 1, overflow: 'auto', background: '#F8F6F3' }}>
        <PageContent />
      </div>
    </div>
  );
}